import { useEffect, useState } from 'react'
import { ProductFruits } from 'react-product-fruits'

import { useCurrentLanguage } from 'lib/tolgee'
import { UserStore } from 'stores'
import getEnvFromLocation from 'utils/getEnvFromLocation'

export default function ProductFruitsHandler() {
  const [forceReRender, setForceReRender] = useState(false)
  const currentLanguage = useCurrentLanguage()
  const languageCode = currentLanguage.split('-')?.[0] ?? 'en'

  const userInfo = UserStore.userInfo
  const isTestUser = userInfo?.email?.includes('cypress')
  const env = getEnvFromLocation()
  const shouldRenderProductFruits = !isTestUser && !['development', 'local', 'test'].includes(env) && userInfo?.id

  const userData = {
    username: userInfo?.id,
    firstName: userInfo?.name,
    role: userInfo?.role,
    email: userInfo?.email,
    signUpAt: new Date(),
    props: {
      companyType: userInfo?.company?.companyType?.name,
      companyName: userInfo?.company?.name,
      jobTitle: userInfo?.jobTitleType?.name,
      country: userInfo?.country,
      releaseType: userInfo?.releaseType,
      companyId: userInfo?.company?.id,
      createdAt: userInfo?.createdAt,
    },
  }

  useEffect(() => {
    setForceReRender(true)
    setTimeout(() => {
      setForceReRender(false)
    }, 100)
  }, [languageCode])

  if (!shouldRenderProductFruits || forceReRender) {
    return null
  }

  return <ProductFruits workspaceCode="aSnPYBGqyARJDJ55" language={languageCode} user={userData} lifeCycle="unmount" />
}
